import { configureStore } from '@reduxjs/toolkit';
import dailyMovementsReducer from './ducks/dailyMovements';
import balancesReducer from './ducks/balances';
import pendingUsersReducer from './ducks/pendingUsers';
import approvedUsersReducer from './ducks/approvedUsers';
import deniedUsersReducer from './ducks/deniedUsers';
import blockedUsersReducer from './ducks/blockedUsers';
import requestedUsersReducer from './ducks/requestedUsers';
import preapprovedUsersReducer from './ducks/preapprovedUsers';
import userReducer from './ducks/user';
import loginReducer from './ducks/login';
import perfisReducer from './ducks/perfis';
import approveUserReducer from './ducks/approveUser';
import denyUserReducer from './ducks/deniedUsers';
import sweetAlertReducer from './ducks/sweetAlert';
import retrievePasswordReducer from './ducks/retrievePassword';
import waitingBankUsersReducer from './ducks/waitingBankUsers';
import bankSlipsReducer from './ducks/bankSlips';
import bankSlipDetailReducer from './ducks/bankSlipDetail';
import paymentsReducer from './ducks/payments';
import paymentDetailReducer from './ducks/paymentDetail';
import systemUserReducer from './ducks/systemUser';
import taxesReducer from './ducks/taxes';
import logsReducer from './ducks/logs';
import blockUserReducer from './ducks/blockUser';
import loanReducer from './ducks/loan';
import loanDetailReducer from './ducks/loanDetail';
import transfersReducer from './ducks/transfers';
import validatePasswordReducer from './ducks/validatePassword';
import listUsersReducer from './ducks/listUsers';
import transactionsReducer from './ducks/transactions';
import digitalServicesReducer from './ducks/digitalServices';
import cobansReducer from './ducks/cobans';
import reportsReducer from './ducks/reports';
import walletsReducer from './ducks/wallets';
import saldoAdminReducer from './ducks/saldoAdmin';
import saldoGeralReducer from './ducks/saldoGeral';
import userAccountsReducer from './ducks/userAccounts';
import accountReducer from './ducks/account';

export default configureStore({
  reducer: {
    dailyMovements: dailyMovementsReducer,
    balances: balancesReducer,
    pendingUsers: pendingUsersReducer,
    approvedUsers: approvedUsersReducer,
    deniedUsers: deniedUsersReducer,
    preapprovedUsers: preapprovedUsersReducer,
    requestedUsers: requestedUsersReducer,
    blockedUsers: blockedUsersReducer,
    bankSlips: bankSlipsReducer,
    bankSlipDetail: bankSlipDetailReducer,
    user: userReducer,
    perfis: perfisReducer,
    approveUser: approveUserReducer,
    denyUser: denyUserReducer,
    sweetAlert: sweetAlertReducer,
    retrievePassword: retrievePasswordReducer,
    waitingBankUsers: waitingBankUsersReducer,
    systemUser: systemUserReducer,
    taxes: taxesReducer,
    login: loginReducer,
    payments: paymentsReducer,
    paymentDetail: paymentDetailReducer,
    logs: logsReducer,
    blockUser: blockUserReducer,
    loan: loanReducer,
    loanDetail: loanDetailReducer,
    transfers: transfersReducer,
    validatePassword: validatePasswordReducer,
    listUsers: listUsersReducer,
    saldoAdmin: saldoAdminReducer,
    saldoGeral: saldoGeralReducer,
    transactions: transactionsReducer,
    digitalServices: digitalServicesReducer,
    cobans: cobansReducer,
    reports: reportsReducer,
    wallets: walletsReducer,
    userAccounts: userAccountsReducer,
    account: accountReducer,
  },
});
